import React from 'react';
import ReactDOM from 'react-dom';
import App from './presentation/App';
import { SnackbarProvider } from 'notistack';
import { initMobileDebug } from './infrastructure/utils/mobile-debug';

// Inject global styles for better mobile scrolling
const globalStyles = `
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: auto; /* Enable vertical scrolling */
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  }
`;

// Init mobile debug panel nếu có ?debug=1
initMobileDebug();

ReactDOM.render(
  <React.StrictMode>
    <style>{globalStyles}</style>
    <SnackbarProvider maxSnack={3}>
      <App />
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
